
import LoadSimple from "../../LoadSimple";
import  "./styles/hostStyles.css";
import Modal from 'react-modal';
import ModalDeleteHost from "./ModalDeleteHost";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'50%',
    height:'30%',
    padding:'20px'
  },
};
const HostsList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  buscar_cis,
  loadingList
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  // useEffect(() => {
  //   buscar_cis();
  // }, []);

  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };

  return (
    <>
      <div className="cont-row-user-list">
        {loadingList ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
              >
                 <div className="field-body-table-mantenimiento field-small">
                 <div className='cont-checkbox'>
                 <input type='checkbox' checked={poolRows.some((row) => row === elemento.hostid)} className='NotifiCheckBox ' style={{height:'15px'}}  onClick={()=>rowSelected(elemento)} ></input>
                </div>
                </div>
                <div className="field-body-table-mantenimiento field-small">
                  {elemento.id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'20%'}}>
                  {elemento.host_padre	}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'20%'}} >
                {elemento.host_hijo	}
                  {/* <div className="tagIpAvailable" style={{color:(elemento.snmp_available==2)?'var(--white-color)':'var(--txt-color)',background:(elemento.snmp_available==0)?'transparent':(elemento.snmp_available==1)?'var(--green-pastel)':'var(--error-color)'}}>
                  
                  </div> */}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'10%'}}>
               
                  {/* <div className="tagIpAvailable" style={{color:(elemento.snmp_available==0 || elemento.snmp_available==undefined)?'var(--txt-color)':'var(--white-color)',background:(elemento.snmp_available==0 || elemento.snmp_available==undefined)?'var(--hover-color)':(elemento.snmp_available==1)?'var(--green-pastel)':'var(--error-color)'}}> */}
                  {elemento.medio	}
                  {/* </div> */}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'10%'}}>
                  {elemento.itemname_status_enlace	}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'10%'}}>
                  {elemento.itemname_throughput_send	}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'10%'}} >
                  {elemento.itemname_throughput_received	}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'10%'}} >
                  {elemento.itemname_alineacion}
                </div>
                
                
                <div className="field-body-table-mantenimiento field-medium" >
                  <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/editar.png"
                    } 
                    onClick={()=>handleChangEdit(elemento)}
                    name="Editar" title="Editar" className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>
                  
                  <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/delete.png"
                    } 
                    onClick={()=>handledeleteUserClick(elemento)}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>
                  
                </div>
              </div>
            ))
        )}
        { (dataList.length == 0 && loadingList==false) ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteHost handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteHost>
    </Modal>
    </>
  );
};

export default HostsList;
